export default __webpack_public_path__ + "static/media/rpt-logo.fee391ad.jpg";